import { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MapContainer, TileLayer } from 'react-leaflet'
import { socket } from 'socket'
import http from 'http'

import getRegion from 'fn/getRegion'

import 'leaflet/dist/leaflet.css'

import Point from './Point'
import EventFilter from './EventFilter'

import { FiCrosshair } from 'react-icons/fi'

const Radar = () => {
  const center = [ 19.804327, -98.853091 ]
  const map = useRef()
  const [ searchParams ] = useSearchParams()
  const [ no, setNo ] =  useState()
  const [ points, setPoints ] = useState( [] )

  // get points
  useEffect( () => {
    http( {
      method: 'GET',
      url: '/radar'
    } )
      .then( ( { data } ) => {
        setPoints( points => {
          return data
        } )
      } )
  }, [] )

  // update no
  useEffect( () => {
    let sp = {}

    for ( let entry of searchParams.entries() ) {
      const [ key, value ] = entry

      sp[ key ] = JSON.parse( value )
    }

    setNo( sp )
  }, [ searchParams ] )

  // connect socket
  useEffect( () => {
    socket.connect()

    return () => {
      socket.disconnect()
    }
  }, [] )

  // join to radar
  useEffect( () => {
    const connectionHandler = () => {
      console.log( 'connected' )

      socket.emit( 'join', 'radar' )
    }

    socket.on( 'connect', connectionHandler )

    return () => {
      socket.off( 'connect', connectionHandler )
    }
  }, [ socket ] )

  // render and update points
  useEffect( () => {
    const pointHandler = ( data ) => {
      setPoints( points => {
        const pIndex = points.findIndex( p => p.user_id === data.user_id )

        data = {
          ...data,
          unix: Date.now()
        }

        if ( pIndex !== -1 ) {
          let aux = [ ...points ]

          aux[ pIndex ] = data

          return aux
        }

        return [ ...points, data ]
      } )
    }

    socket.on( 'point', pointHandler )

    return () => {
      socket.off( 'point', pointHandler )
    }
  }, [ socket ] )

  // destroy
  useEffect( () => {
    const destroyHandler = ( data ) => {

      setPoints( points => {
        const aux = [ ...points ]
          .filter( p => p.user_id !== data.user_id )

        return aux
      } )
    }

    socket.on( 'drop_pin', destroyHandler )

    return () => {
      socket.off( 'drop_pin', destroyHandler )
    }
  }, [] )

  // bound
  useEffect( () => {
    if ( points.length === 0 ) return

    // console.log( 'updated points', no )

    bound()
  }, [ points ] )

  // bound if filter
  useEffect( () => {
    if ( ! map.current ) return

    bound()
  }, [ no ] )

  const bound = () => {
    if ( points.length === 0 ) return

    // event
    let pointsOnEvent = []
    if ( no.events && no.events.length > 0 ) {
      pointsOnEvent = points
        .filter( p => {
          const inEvent = no.events.find( e => p.event && p.event.identity === e )

          return inEvent ? true : false
        } )
    }

    // points
    let pointsInPoints = []
    if ( no.points && no.points.length > 0 ) {
      pointsInPoints = points
        .filter( p => {
          const inPoints = no.points.find( a => a === p.user_id )

          return inPoints ? true : false
        } )
    }

    let pointsToRegion = [ ...pointsInPoints, ...pointsOnEvent ]
    if ( pointsToRegion.length === 0 )
      pointsToRegion = [ ...points ]

    const region = getRegion( pointsToRegion.map( p => p.point ) )

    map.current.fitBounds( region )
  }

  return <div className="one hs">

    <div className="bar">
      <div className="icon">
        <FiCrosshair />
      </div>

      <h1>radar</h1>

      <EventFilter
      />
    </div>

    <MapContainer ref={ map } className="one" center={ center } zoom={16} scrollWheelZoom={true}>

      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      { /*
        url="https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png"
        url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      */ }

      { points.length > 0 ? points.map(
        ( p, index ) => <Point
          key={ index }
          config={ p }
        />
      ) : null }

    </MapContainer>
  </div>
}

export default Radar
